export enum DoorState {

    Secure = 'Secure',
    SecureUsePin = 'Secure, Use Pin',
    Free = 'Free',
	FreeUsePin = 'Free, Use Pin',
    UsePin = 'UsePin',
    
}